export default {
  pageTitle: '管理代金券',
  region: '国别',
  statusFiltering: '状态过滤',
  radio1: '所有',
  radio2: '待发放',
  radio3: '未使用',
  radio4: '已使用',
  radio5: '已过期',
  timeFiltering: '时间过滤',
  placeholder1: '订单ID',
  placeholder2: '订单编号',
  placeholder3: '优惠券编码',
  placeholder4: '用户ID',
  placeholder5: '电话',
  sure: '您确认要禁用它吗？',
  timeType1: '创建时间',
  timeType2: '领取或发放时间',
  timeType3: '过期时间',
  columns1: 'ID',
  columns2: '编号',
  columns3: '模版名',
  columns4: '优惠券批次id',
  columns5: '创建时间',
  columns6: '条件',
  columns7: '面额',
  columns8: '限制',
  columns9: '领取或发放时间',
  columns10: '使用时间', // 原文里一开始就是两个user time
  columns11: '使用时间',
  columns12: '过期时间',
  columns13: '限制类型 ',
  columns14: '所有者类型 ',
  columns15: '状态',
  columns16: '用户ID',
  columns17: '用户名',
  columns18: '禁用',
  // --------------------------
  ownerType1: '平台',
  ownerType2: '店铺',
  status1: '待领取',
  status2: '未使用',
  status3: '已使用',
  status4: '已过期',
  status5: '已失效',
  buttonValue1: '失效'
}
